/* eslint-disable react/jsx-props-no-spreading */
import { GridCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import styled from 'styled-components';
import EmailSvg from '../../images/email.svg';
import { CellHead } from './MobileSummaryCellItem';

const FullNameAndEmailCell = (cellProps: GridCellProps) => (
	<td>
		<FullNameAndEmailCellContent {...cellProps} />
	</td>
);

export default FullNameAndEmailCell;

const TextAndIconCellContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const FullNameAndEmailCellContent = (props: Props) => (
	<TextAndIconCellContainer>
		<span>
			<CellHead>{props.title ? `${props.title}: ` : ''}</CellHead>
			{props.dataItem.firstName} {props.dataItem.lastName}
		</span>
		<a href={`mailto:${props.dataItem.email}`}>
			<img src={EmailSvg} alt="Email Icon" />
		</a>
	</TextAndIconCellContainer>
);

interface Props extends GridCellProps {
	title?: string;
}
